import { useEffect, useState } from "react";
import { FaGoogle } from "react-icons/fa";
//import { useNavigate } from "react-router-dom";
import BaseModal, { FRONTEND_URL } from "./BaseModal";
import styles from "./BaseModal.module.css";
import { authClient } from "../../lib/auth-client";

let openSignInModalRef: (() => void) | null = null;

export function showSignInModal() {
  openSignInModalRef?.();
}

export default function SignInModal() {
  //const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    openSignInModalRef = () => {
      setErrorMsg("");
      setOpen(true);
    };

    return () => {
      openSignInModalRef = null;
    };
  }, []);

  function closeModal() {
    setOpen(false);
    setLoading(false);
    setErrorMsg("");
  }

  function hasEmailAndPassword() {
    return email.trim() !== "" && password.trim() !== "";
  }

  async function handleSave() {
    setLoading(true);
    setErrorMsg("");

    await authClient.signIn.email(
      {
        email,
        password,
        callbackURL: "/dashboard",
        rememberMe: true,
      },
      {
        onSuccess: () => {
          closeModal();
          //navigate("/dashboard");
        },
        onError: (ctx) => {
          if (ctx.error.status === 403) {
            alert("Please verify your email address");
          } else {
            alert("Credenciais incorretas");
          }

          setErrorMsg(ctx.error.message || "Erro ao fazer login.");
          setLoading(false);
        },
      }
    );
  }

  async function handleGoogleSignIn() {
    setLoading(true);
    setErrorMsg("");

    const result = await authClient.signIn.social({
      provider: "google",
      callbackURL: `${FRONTEND_URL}/dashboard`,
    });

    if (result.error) {
      setErrorMsg(result.error.message || "Erro ao autenticar com Google.");
      setLoading(false);
      return;
    }

    console.log("[SignInModal] handleGoogleSignIn:success -> navigate /dashboard");
    closeModal();
    //navigate("/dashboard");
  }

  async function handleForgotPassword() {
    const cleanEmail = email.trim();
    if (!cleanEmail) {
      setErrorMsg("Informe seu email para recuperar a senha.");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    const { error } = await authClient.requestPasswordReset({
      email: cleanEmail,
      redirectTo: `${FRONTEND_URL}/reset-password`,
    });

    if (error) {
      setErrorMsg(error.message || "Erro ao solicitar reset de senha.");
      setLoading(false);
      return;
    }

    alert("Se este email existir, você receberá um link para redefinir a senha.");
    setLoading(false);
  }

  async function handlePrimaryAction() {
    if (loading) return;

    if (hasEmailAndPassword()) {
      await handleSave();
      return;
    }

    await handleGoogleSignIn();
  }

  useEffect(() => {
    if (!open) return;

    async function handleKeyDown(event: KeyboardEvent) {
      if (event.key !== "Enter") return;

      event.preventDefault();
      await handlePrimaryAction();
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, loading, email, password]);

  return (
    <BaseModal
      open={open}
      title="Sign in"
      subtitle="Entre com email e senha"
      onCancel={closeModal}
    >
      <div className={styles.body}>
        <div className={styles.formGroup}>
          <label className={styles.label}>Email</label>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@email.com"
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.label}>Senha</label>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
          />
        </div>

        {errorMsg ? (
          <p className={styles.errorMessage}>{errorMsg}</p>
        ) : null}

        <div className={styles.actions}>
          <button
            type="button"
            onClick={handleForgotPassword}
            disabled={loading || !email.trim()}
            style={{
              border: "none",
              background: "transparent",
              padding: 0,
              marginRight: "auto",
              textAlign: "left",
              cursor: loading || !email.trim() ? "not-allowed" : "pointer",
              textDecoration: "underline",
              opacity: loading || !email.trim() ? 0.6 : 1,
            }}
          >
            Esqueci a minha senha
          </button>

          <button
            type="button"
            onClick={closeModal}
            className={`${styles.button} ${styles.buttonSecondary}`}
            disabled={loading}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handlePrimaryAction}
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading}
          >
            {loading ? "Entrando..." : "Ok"}
          </button>
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            onClick={handleGoogleSignIn}
            className={`${styles.button} ${styles.buttonPrimary}`}
            disabled={loading}
          >
            {loading ? (
              "Redirecionando..."
            ) : (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <span>Entrar com Google</span>
                <FaGoogle />
              </span>
            )}
          </button>
        </div>
      </div>
    </BaseModal>
  );
}
